import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/web.dom-collections.for-each.js";
import validate from './index';
var obj = {};
Object.keys(validate).forEach(function (item) {
  obj[item] = function (rule, value, callback) {
    if (validate[item](value)) {
      callback();
    }
    callback(new Error());
  };
});
export default _objectSpread(_objectSpread({}, obj), {}, {
  auditLevel: function auditLevel(rule, value, callback) {
    if (value) {
      if (!/^.*(.).*\1/i.test(value)) {
        if (/^[1-5]{0,5}$/gi.test(value)) {
          if (typeof value === 'number') {
            value = '' + value;
          }
          var arr = value.split('');
          for (var i = 0; i < arr.length; i++) {
            if (arr[i] > arr[i + 1]) {
              return callback(new Error('只能输入12345的组合,且由小到大'));
            }
          }
          return callback();
        }
      }
    } else if (value === undefined || value === '') {
      return callback();
    }
    return callback(new Error('只能输入12345的组合,由小到大,不允许重复'));
  },
  blockStr: function blockStr(rule, value, callback) {
    if (/['`~!@#$%^&*()=|{}":;,./?\[\]\\<>￥…（）—【】‘；：”“。，、？]/gi.test(value)) {
      return callback(new Error('禁止输入特殊符号'));
    } else if (/\s+/gi.test(value)) {
      return callback(new Error('禁止输入空格'));
    } else if (/^-/gi.test(value)) {
      return callback(new Error('-符号禁止出现在第一个'));
    } else if (/-$/gi.test(value)) {
      return callback(new Error('-符号禁止出现在最后一个'));
    }
    return callback();
  },
  checkPhone: function checkPhone(rule, value, callback) {
    if (value) {
      console.log(value);
      if (/^(?:(?:\+|00)86)?1\d{10}$/.test(value)) {
        return callback();
      } else {
        return callback(new Error('请输入正确的手机号码'));
      }
    } else {
      if (rule.required) {
        return callback(new Error('请输入手机号码'));
      }
    }
  }
});